import React, { useState, useRef } from "react";
import { addCorpusDocuments, createCorpus, getCorpus } from "containers/LanguageModelArtifact/reducer";
import { getSelectedAccountId } from "containers/Accounts/reducer";
import { getSelectedFolder } from "containers/Folders/reducer";
import { useSelector, useDispatch } from "types/store";
import { Button } from "aible";
import { getDefaultEmbeddingsModel } from "containers/ChatGPT/reducer";
const UploadDocument = ({ artifactId, style, isSmall, isLoading, type, onStart, onCreate, onComplete, isCreate, skipWaitForReindex, ...retProps }) => {
    const dispatch = useDispatch();
    const inputElement = useRef(null);
    const [isUploading, updateIsUploading] = useState(false);
    const selectedArtifact = useSelector((state) => (!isCreate ? getCorpus(state, artifactId ?? -1) : undefined));
    const accountId = useSelector((state) => getSelectedAccountId(state));
    const folderId = useSelector((state) => getSelectedFolder(state));
    const model = useSelector((state) => getDefaultEmbeddingsModel(state, accountId));
    const allowedExtensions = [".pdf", ".csv", ".html", ".md"];
    const checkFileType = (file) => {
        const fileName = file?.name;
        const dotIndex = fileName?.lastIndexOf(".");
        const fileExtension = fileName?.slice(dotIndex);
        if (fileName && dotIndex !== -1 && allowedExtensions.includes(fileExtension.toLowerCase())) {
            return true;
        }
        return false;
    };
    const checkIsCreate = (files) => {
        if (selectedArtifact !== undefined) {
            return Promise.resolve(selectedArtifact);
        }
        const name = files.find((f) => f?.name)?.name ?? "New Document Set";
        return dispatch(createCorpus(accountId, folderId, name, model));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Button
        // onClick={() => document.getElementById("fUploadLLMDocs_" + artifactId)?.click()}
        , { 
            // onClick={() => document.getElementById("fUploadLLMDocs_" + artifactId)?.click()}
            onClick: (e) => {
                e.stopPropagation();
                inputElement.current?.click();
            }, type: type ?? "secondary", isSmall: isSmall ?? true, style: {
                whiteSpace: "nowrap",
                marginRight: "5px",
                ...style
            }, isLoading: isLoading ?? isUploading, loadingText: isUploading && isCreate ? (React.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "flex-start" } },
                React.createElement("div", { style: { fontSize: "13px", color: "#8d8d8d" } }, "PROCESSING."),
                React.createElement("div", { style: { fontSize: "13px", fontWeight: 400 } }, "THIS MAY TAKE LONGER FOR LARGER DOCUMENTS"))) : undefined, ...retProps }, `Upload Document`),
        React.createElement("div", { style: { display: "none" } },
            React.createElement("input", { type: "file", id: "fUploadLLMDocs_" + artifactId, ref: inputElement, accept: ".pdf, .csv, .html, .md", multiple: true, onChange: (e) => {
                    const currInput = e.currentTarget;
                    const rawFiles = currInput.files;
                    if (rawFiles === null) {
                        return;
                    }
                    const rawFilesArray = Array.from(rawFiles);
                    const allFilesPass = rawFilesArray.every((file) => {
                        const result = checkFileType(file);
                        return result;
                    });
                    if (!allFilesPass) {
                        e.currentTarget.value = "";
                        return alert("This document is not supported. You can upload the following document types: PDF, CSV, HTML, and Markdown");
                    }
                    const files = rawFilesArray.slice();
                    if (files?.length > 0) {
                        updateIsUploading(true);
                        if (onStart) {
                            onStart();
                        }
                        return checkIsCreate(files)
                            .then((artifact) => {
                            if (skipWaitForReindex) {
                                updateIsUploading(false);
                            }
                            if (onCreate) {
                                onCreate(artifact);
                            }
                            return dispatch(addCorpusDocuments(artifact, files)).then(() => {
                                if (!skipWaitForReindex) {
                                    updateIsUploading(false);
                                }
                                if (onComplete) {
                                    onComplete(artifact);
                                }
                                currInput.value = "";
                                return artifact;
                            });
                        })
                            .catch((e) => {
                            updateIsUploading(false);
                            if (onComplete) {
                                onComplete();
                            }
                            currInput.value = "";
                            throw e;
                        });
                    }
                } }))));
};
export default UploadDocument;
